import {Component, OnInit, ChangeDetectionStrategy, ElementRef, Input, ViewEncapsulation, OnChanges, SimpleChanges} from '@angular/core';
import {SvgService} from 'app/core/services/svg.service';

@Component({
    selector: 'svg-image',
    templateUrl: './svg-image.component.html',
    styleUrls: ['./svg-image.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgImageComponent implements OnInit, OnChanges {
    @Input() name: string;
    @Input() replaceElementOnChanges: boolean;

    constructor(
        private element: ElementRef<HTMLElement>,
        private service: SvgService
    ) {}

    ngOnInit() {
        this.element.nativeElement.appendChild(this.service.get(this.name)); // TODO: create a method
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.replaceElementOnChanges || !this.element?.nativeElement?.children[0]) {
            return;
        }

        this.element.nativeElement.replaceChild(this.service.get(this.name), this.element.nativeElement.children[0]);
    }
}
